import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useContext } from 'react';
import { en_US } from './en_US';
var LocaleContext = createContext(en_US);
export var useLocale = function useLocale() {
  return useContext(LocaleContext);
};
export var LocaleProvider = function LocaleProvider(_ref) {
  var _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? {} : _ref$locale,
      children = _ref.children;
  return React.createElement(LocaleContext.Provider, {
    value: _objectSpread({}, en_US, {}, locale)
  }, children);
};